import React from "react"
import { Box } from "@rebass/grid/emotion"
import Tag from "../tag/tag"

const Tags = ({ items }) => {
  return (
    <Box>
      {items.map((item, i) => {
        const data = {
          line: item,
          classes: `bg-nova-base-solid-20 mr-1 mb-1 sm:mr-2 sm:mb-2`,
        }
        return <Tag data={data} key={i} />
      })}
    </Box>
  )
}
export default Tags
